<template>
    <div>
        <v-card>
            <v-card-title>
                <i18n path="settings.details.captainsWithPackage" tag="span"><template #name><b> {{package.name}} </b></template></i18n>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        :label="$t('common.search')"
                        single-line
                        hide-details
                        @keyup.enter="getData"
                ></v-text-field>
                <v-btn color="primary" @click="dialog=true">{{ $t("settings.details.new") }}</v-btn>
            </v-card-title>
            <v-data-table :headers="headers" :items="package.captains" :loading="loading">
                <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.id }}</td>
                    <td class="text-xs-left">
                        <router-link style="text-align: center;text-decoration: none" :to="'/captains/' + props.item.id"
                                     target="_blank">
                            <b>{{ props.item.first_name }} {{props.item.last_name}}</b>
                        </router-link>
                    </td>
                    <td class="text-xs-left">{{ props.item.start_date }}</td>
                    <td class="text-xs-left">
                        <v-btn color="danger" @click="detach(props.item.id, props.item.first_name)">{{ $t("settings.details.detach") }}</v-btn>
                    </td>
                </template>
                <v-alert v-slot:no-results :value="true" color="error" icon="warning">
                    {{ $t("settings.details.noResults", { search }) }}
                </v-alert>
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" width="40%">
            <v-card>
                <v-card-title>
                    {{ $t("settings.details.addNewCaptains") }}
                </v-card-title>
                <v-card-text>
                    <choose-captains-multi :label="$t('settings.details.captains')" v-model="model.captains"></choose-captains-multi>
                    <v-label>
                        {{ $t("settings.details.uploadCsv") }}
                    </v-label>
                    <input type="file" accept=".csv,.txt" @change="passengersCSVChanges"/>

                    <p style="margin-top: 10px"><b>{{ $t("settings.details.joinDate") }}</b></p>
                    <v-date-picker v-model="model.join_date"></v-date-picker>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="save" :disabled="loading">{{ $t("common.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";
    import CarInfo from "@/components/confirmation_captain_components/CarInfo";
    import RidePage from "@/views/RidePage";
    import socketEventsMixin from "@/mixins/socketEventsMixin";
    import ChooseCaptainsMulti from "@/components/monaco/input/ChooseCaptainMulti";

    export default {
        mixins: [socketEventsMixin],
        name: "Package captains",
        title() {
            return this.$t("settings.details.title");
        },
        components: {ChooseCaptainsMulti, CarInfo, DataTable, RidePage},
        data() {
            return {
                package: {
                    captains: []
                },
                loading: false,
                search: '',
                dialog: false,
                model: {
                    join_date: null,
                    captains: []
                }
            };
        },
        mounted() {
            this.getData();
        },
        computed: {
            headers() {
                return [
                    {text: this.$t('settings.details.id'), value: 'id'},
                    {text: this.$t('settings.details.captain'), value: 'captain_name'},
                    {text: this.$t('settings.details.startDate'), value: 'start_date'},
                    {text: this.$t('common.actions'), value: 'actions'},
                ];
            },
            map_ids() {
                return this.model.captains.map(item => item.id ? item.id : item);
            }
        },
        methods: {
            getData() {
                this.loading = true;
                this.axios.get(`bonus_package/${this.$route.params.id}?search=${this.search}`)
                    .then(res => this.package = res.data.data)
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            },
            passengersCSVChanges(e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    if (files[0].name.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader();
                    fr.readAsText(files[0]);
                    fr.addEventListener('load', () => {
                        this.model.captains = fr.result.split("\n").filter(
                            item => !isNaN(parseInt(item)) && parseInt(item) == item
                        );
                    })
                }
            },

            save() {
                this.loading = true;
                console.log(this.model);
                this.axios.post(`bonus_package/${this.$route.params.id}/captains`, {
                    join_date: this.model.join_date,
                    captains: this.model.captains
                })
                    .then(() => {
                        this.getData();
                        this.dialog = false;
                        window.getApp.$emit("SHOW_TOAST", this.$t('settings.details.success'));
                    })
                    .catch(err => {
                        try {
                            if (err.response.data.message) {
                                window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", ['center', 'top']);
                            } else {
                                window.getApp.$emit("SHOW_TOAST", err.message, "red", ['center', 'top']);
                            }
                        } catch (e) {
                            console.log(err.message, e.message);
                        }
                    })
                    .finally(() => this.loading = false, this.model.captains = []);
            },
            detach(captain_id, name) {
                let c = confirm(this.$t('settings.details.confirmDetach', { name }));
                if (!c) {
                    return
                }
                this.loading = true;
                this.axios.delete(`bonus_package/${this.$route.params.id}/captains/${captain_id}`)
                    .then(() => {
                        this.getData();
                        this.dialog = false;
                        window.getApp.$emit("SHOW_TOAST", this.$t('settings.details.success'));
                    })
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            }
        }
    }
</script>

<style scoped>

</style>
